app.factory("$filter_text",function(_$filter){
    
    
    return {
        
      prefilter:function(scope){
          return scope.model.value;
      },
      getTemplate:function(){
          
          
          return _$filter.getPath()+"/adapters/text.html";
      }  
        
    };
    
});

